import React from 'react';
import { Form, Input, Yup } from '111-react-simpleform';
import './LoginForm.less';
import { Item, Row, Column } from 'react-plan';
import Axios from 'axios';
import { Auth } from '../../firebaseInit.js';
import Loader from './../../app/App/Loader.jsx';
import Button from '../../../common/js/app/Button/Button.jsx';

type Props = {

}
const strings = {
  welcome: 'Welcome to WSS !',
  email: 'Email address',
  password: 'Password',
  login: 'Login',
  401: 'Wrong username / password combination',
  back: 'Back to the main site'
};

const schema = Yup.object().shape({
  email: Yup.string().email().required(),
  password: Yup.string().min(6).max(32).required()
});

class LoginForm extends React.Component {

  description: 'Login form connecting to the auth API.'

  props: Props

  constructor(props: Props) {
    super(props);
    this.state = {
      loading: false
    };
  }

  /* Component Custom Methods */
  handleSubmit = ({email, password}) => {
    this.setState({
      loading: true
    });
    Axios.post(`${__AUTH_API_URL__}/login`, {
      email: email,
      password: password,
      scope: 'student'
    }).then(({data}) => {
      const { token } = data;
      Auth.signInWithCustomToken(token);
    }).catch((err) => {
      this.setState({
        loading: false,
        error: err.status
      });
    });
  }
  /* End Component Custom Methods */

  /* React Component LifeCycle Methods */
  //componentWillMount() {}
  //componentDidMount() {}
  //componentWillReceiveProps(nextProps) {}
  //shouldComponentUpdate(nextProps, nextState) {}
  //componentWillUpdate(nextProps, nextState) {}
  //componentDidUpdate(prevProps, prevState) {}
  //componentWillUnmount() {}
  render() {
    const error = (this.state.error) ? <p style={ { color: 'red' } }>{ strings[this.state.error]}</p> : null;
    switch (this.state.loading) {
      case true:
        return <Loader />;
      default:
        return (
          <div className="login bg-login">
            <Row justify="center" className="center">
              <Item
                className="login-box"
                size="400px"
                small="345px"
                >
                <h2 className="m-t m-b txt-center">{ strings.welcome }</h2>
                <Form onSubmit={ this.handleSubmit } schema={ schema }>
                  <Input
                    label={ strings.email }
                    name="email"
                    type="email"
                    />
                  <Input
                    label={ strings.password }
                    name="password"
                    type="password"
                    />

                  <div className="m-t m-b">
                    <Button type="submit">{ strings.login }</Button>
                  </div>

                  <div className="text-center m-t m-b">
                    <a href="https://www.worldspaceschool.jp/">{ strings.back }</a>
                  </div>
                </Form>
                { error }
              </Item>
              <img
                alt="galaxy"
                className="rotating galaxy"
                src={ require('../../../img-layout/bg-log.jpg') } />
            </Row>
          </div>



        );
    }
  }
  /* End React Component LifeCycle Methods */
}

export default LoginForm;

//Unit test entry point
export const _LoginForm = LoginForm;


/** WEBPACK FOOTER **
 ** ./src/js/auth/LoginForm/LoginForm.jsx
 **/